
  const __registry__ = require('../../../spiferack/client/index.js')
  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = require('prop-types');
var connect = require('../../components/connect');

var ProfileTabs = require('../../components/profile/tabs');
var Orgs = require('../../components/profile/orgs');
var Packages = require('../../components/profile/packages');
var NextButton = require('../../components/profile/nextButton');
var Avatar = require('@npm/design-system/avatar/avatar');
var YourAccount = require('../../components/profile/yourAccount');
var Links = require('../../components/profile/links');

var _require = require('../../components/profile/containers'),
    Container = _require.Container,
    Content = _require.Content,
    Sidebar = _require.Sidebar;

var _require2 = require('../../utils/aria-live'),
    announce = _require2.announce;

var Profile = function (_React$Component) {
  _inherits(Profile, _React$Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      announce('Profile');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          scope = _props.scope,
          account = _props.account,
          orgs = _props.orgs,
          packages = _props.packages,
          user = _props.user,
          _props$activeTab = _props.activeTab,
          activeTab = _props$activeTab === undefined ? 'packages' : _props$activeTab,
          dispatch = _props.dispatch,
          isAccountLinkEnabledForUser = _props.isAccountLinkEnabledForUser,
          _props$isTabPanel = _props.isTabPanel,
          isTabPanel = _props$isTabPanel === undefined ? true : _props$isTabPanel;

      var onClick = function onClick() {
        dispatch('SHOW_PACKAGES_LOADING');
        dispatch('FETCH_PACKAGES', { url: packages.urls.next });
      };

      var isCurrentUser = user && user.name === scope.parent.name;
      scope.isAccountLinkEnabledForUser = isAccountLinkEnabledForUser;
      scope.isCurrentUser = isCurrentUser;

      return React.createElement(
        Container,
        null,
        React.createElement(
          Sidebar,
          null,
          scope.type === 'user' && React.createElement(Avatar, {
            src: scope.parent.avatars.large,
            href: 'http://en.gravatar.com/emails/',
            size: 200,
            title: '',
            'aria-label': 'Your profile picture'
          }),
          React.createElement(Links, { scope: scope }),
          isCurrentUser && React.createElement(YourAccount, { userName: user.name })
        ),
        React.createElement(
          Content,
          null,
          scope.type === 'user' && React.createElement(ProfileTabs, { packageCount: packages.total, orgCount: orgs.total, active: activeTab }),
          activeTab === 'orgs' && React.createElement(Orgs, { orgs: orgs, isCurrentUser: isCurrentUser, isTabPanel: isTabPanel }),
          (activeTab === 'packages' || scope.type !== 'user') && [React.createElement(Packages, {
            packages: packages,
            isCurrentUser: isCurrentUser,
            isTabPanel: isTabPanel,
            isSubscribed: account.isSubscribed,
            scope: scope,
            key: 'packages'
          }), packages.urls && React.createElement(NextButton, {
            key: 'pagination',
            urls: packages.urls,
            onClick: onClick,
            loading: this.props.profilePackagesLoading
          })]
        )
      );
    }
  }]);

  return Profile;
}(React.Component);

Profile.propTypes = {
  scope: PropTypes.object,
  orgs: PropTypes.object,
  packages: PropTypes.object,
  isTabPanel: PropTypes.bool
};

Profile.defaultProps = {
  account: {},
  orgs: {
    total: 0,
    objects: []
  },
  packages: {
    total: 0,
    objects: []
  }
};

module.exports = connect()(Profile);
  let __hot__
  
  __registry__.register('profile/profile', module.exports, __hot__)
  